module.exports = __webpack_public_path__ + "media/images/area/popular/shinjuku-d20a43b59e0b4a6ad58279df70eb536a.jpg";